import Vue from "vue";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import "../../../../filters";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";

export default {
  name: "EmployeesSchedules",
  mixins: [validationMixin],
  components: {
    ScheduleComp: require("./schedule.vue").default,
  },
  props: ["dataObj"],
  data: function () {
    return {
      appId: -1,
      activityId: -1,
      schedules: [],
      employees: [],
      rateTypes: [],
      usageTypes: [],
      periodTypes: [],
      orgPosts: [],
      stations: [],
      deleteConfirmMessage: "",
      bScheduleDialog: false,
      bConfirmDialog: false,
      editingSchedule: {},
      editingScheduleClone: {},
      message: "",
    };
  },
  validations: {
    maintenanceValue: {
      required,
    },
  },
  created() {
    this.$material.locale.dateFormat = "dd/MM/yyyy";
    this.$root.$on("employees_schedules_updated", this.init);
    this.init();
  },
  methods: {
    formatMoney(number, decPlaces, decSep, thouSep) {
      (decPlaces = isNaN((decPlaces = Math.abs(decPlaces))) ? 2 : decPlaces),
        (decSep = typeof decSep === "undefined" ? "." : decSep);
      thouSep = typeof thouSep === "undefined" ? "," : thouSep;
      var sign = number < 0 ? "-" : "";
      var i = String(
        parseInt((number = Math.abs(Number(number) || 0).toFixed(decPlaces)))
      );
      var j = (j = i.length) > 3 ? j % 3 : 0;

      return (
        sign +
        (j ? i.substr(0, j) + thouSep : "") +
        i.substr(j).replace(/(\decSep{3})(?=\decSep)/g, "$1" + thouSep) +
        (decPlaces
          ? decSep +
            Math.abs(number - parseInt(i))
              .toFixed(decPlaces)
              .slice(2)
          : "")
      );
    }, //this.formatMoney(item.closingBalance, 2, '.', ',');
    init() {
      Vue.nextTick(() => {
        this.appId = this.dataObj.appId;
        this.activityId = this.dataObj.activityId;
        this.dataObj.appData.employeeSchedules.forEach((p) => {
          if (!p.uuid || p.uuid === null || p.uuid.length === 0)
            p.uuid = uuidv4();
          p.periodDuration = this.calculateDuration(p.periodEnd, p.periodBegin);
        });
        if (this.dataObj.appData.employeeSchedules)
          this.schedules = this.dataObj.appData.employeeSchedules;
        else this.dataObj.appData.employeeSchedules = [];
        this.employees = this.dataObj.appData.employees;
        this.rateTypes = this.dataObj.appData.rateTypes;
        this.usageTypes = this.dataObj.appData.usageTypes;
        this.periodTypes = this.dataObj.appData.periodTypes;
        this.orgPosts = this.dataObj.appData.orgPosts;
        this.stations = this.dataObj.appData.stations;
        //console.log("schedules dataObj:", this.dataObj);
      });
    },
    calculateDuration(start, end) {
      //find difference and cinvert it to mis
      let t = (Date.parse(start) - Date.parse(end)) / 1000 / 60;
      return t.toString();
    },
    addSchedule() {
      this.editingScheduleClone = {
        isMultiple: true,
        isEdit: false,
        selection: [],
        id: 0,
        applicationId: 0,
        activityId: 0,
        employeeId: 0,
        employee: "",
        rateTypeId: 0,
        rateType: "",
        usageTypeId: 0,
        usageType: "",
        periodTypeId: 0,
        periodType: "",
        stationId: this.dataObj.appRecord.stationId,
        periodDate: moment(new Date()).format(),
        periodBegin: moment(new Date()).format(),
        periodEnd: moment(new Date()).format(),
        periodDuration: "0",
        comment: "",
        uuid: uuidv4(),
      };
      this.editingScheduleClone.employees = this.employees;
      this.editingScheduleClone.rateTypes = this.rateTypes;
      this.editingScheduleClone.usageTypes = this.usageTypes;
      this.editingScheduleClone.periodTypes = this.periodTypes;
      this.editingScheduleClone.orgPosts = this.orgPosts;
      this.editingScheduleClone.stations = this.stations;
      this.bScheduleDialog = true;
    },
    editSchedule(item) {
      this.editingSchedule = item;
      this.editingScheduleClone = JSON.parse(JSON.stringify(item));
      this.editingScheduleClone.employees = this.employees;
      this.editingScheduleClone.rateTypes = this.rateTypes;
      this.editingScheduleClone.usageTypes = this.usageTypes;
      this.editingScheduleClone.periodTypes = this.periodTypes;
      this.editingScheduleClone.stationId = this.dataObj.appRecord.stationId;
      this.editingScheduleClone.orgPosts = this.orgPosts;
      this.editingScheduleClone.stations = this.stations;
      this.editingScheduleClone.isMultiple = false;
      this.editingScheduleClone.selection = [];
      this.editingScheduleClone.isEdit = true;

      this.bScheduleDialog = true;
    },
    removeConfirm(item) {
      this.deleteConfirmMessage =
        this.$t("omApplication.DeleteSchedule") +
        " [" +
        item.id +
        ". " +
        item.employee +
        "] ?";
      this.editingSchedule = item;
      this.bConfirmDialog = true;
    },
    removeSchedule() {
      this.dataObj.appData.employeeSchedules =
        this.dataObj.appData.employeeSchedules.filter(
          (p) => p.uuid !== this.editingSchedule.uuid
        );
      this.schedules = this.dataObj.appData.employeeSchedules;
    },
    saveSchedule() {
      //console.log("editClone", this.editingScheduleClone);
      //console.log("data", this.dataObj.appData.employees);

      //error checks
      if (!this.editingScheduleClone.selection) {
        this.bScheduleDialog = false;
        this.$forceUpdate();
        return;
      }

      if (
        this.editingScheduleClone.periodTypeId == 1 &&
        (this.editingScheduleClone.periodBegin == null ||
          this.editingScheduleClone.periodBegin == "" ||
          this.editingScheduleClone.periodEnd == null ||
          this.editingScheduleClone.periodEnd == "")
      ) {
        this.$alertMsg(this.$t("messages.completeStarEndTime"), 3);
        return;
      }

      if (
        this.editingScheduleClone.periodDuration <= 0 &&
        this.editingScheduleClone.periodTypeId == 1
      ) {
        this.$alertMsg(this.$t("messages.wrongStarEndTime"), 3);
        return;
      }

      this.editingScheduleClone.periodEnd = this.convertDate(
        this.editingScheduleClone.periodEnd
      );
      this.editingScheduleClone.periodDate = this.convertDate(
        this.editingScheduleClone.periodDate
      );
      this.editingScheduleClone.periodBegin = this.convertDate(
        this.editingScheduleClone.periodBegin
      );

      this.dataObj.appData.employeeSchedules =
        this.dataObj.appData.employeeSchedules.filter(
          (p) => p.uuid !== this.editingScheduleClone.uuid
        );
      const isMultiple = this.editingScheduleClone.isMultiple;
      const selection = this.editingScheduleClone.selection;

      delete this.editingScheduleClone.employees;
      delete this.editingScheduleClone.rateTypes;
      delete this.editingScheduleClone.usageTypes;
      delete this.editingScheduleClone.periodTypes;
      delete this.editingScheduleClone.isMultiple;
      delete this.editingScheduleClone.selection;
      delete this.editingScheduleClone.orgPosts;
      delete this.editingScheduleClone.stations;

      selection.forEach((p) => {
        const schedule = JSON.parse(JSON.stringify(this.editingScheduleClone));
        const employee = this.employees.filter((e) => e.employeeId === p.id)[0];
        //console.log("emp", employee);
        schedule.employeeId = p.id;
        schedule.applicationId = parseInt(this.appId);
        schedule.periodDuration = this.editingScheduleClone.periodDuration;
        schedule.activityId = this.activityId;
        schedule.periodTypeId = this.editingScheduleClone.periodTypeId;
        schedule.periodType = this.periodTypes.filter(
          (p) => p.value == this.editingScheduleClone.periodTypeId
        )[0].text;

        schedule.rateTypeId = parseInt(schedule.rateTypeId);
        schedule.rateHr = parseInt(
          employee.rateHours != null
            ? employee.rateHours[schedule.rateTypeId]
            : ""
        );
        schedule.usageTypeId = parseInt(schedule.usageTypeId);
        schedule.employee = employee.displayString;
        schedule.orgPost = employee.orgPostName;
        schedule.orgPostId = employee.orgPost;
        schedule.uuid = uuidv4();
        this.dataObj.appData.employeeSchedules.push(schedule);
      });

      //console.log("schedules", this.dataObj.appData.employeeSchedules);

      this.schedules = this.dataObj.appData.employeeSchedules;
      this.bScheduleDialog = false;
      this.$forceUpdate();
    },
    convertDate(val) {
      let valDate = new Date(val);
      let perDate = new Date(this.editingScheduleClone.periodDate);

      //construct final date in sql datetime format from period date base and hours from val
      let date =
        perDate.getFullYear() +
        "-" +
        ("00" + (perDate.getMonth() + 1)).slice(-2) +
        "-" +
        ("00" + perDate.getDate()).slice(-2) +
        "T" +
        ("00" + valDate.getHours()).slice(-2) +
        ":" +
        ("00" + valDate.getMinutes()).slice(-2) +
        ":" +
        "00";

      return date;
    },
    closeDialog() {
      this.bScheduleDialog = false;
    },
  },
};
